/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.61"
        height="95.45"
        viewBox="0 0 85.61 95.45"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M62.44 44.24a15.43 15.43 0 1 0 15.42 15.43 15.42 15.42 0 0 0-15.42-15.43Zm0 2a13.43 13.43 0 1 1-13.42 13.43 13.42 13.42 0 0 1 13.42-13.43Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M62.44 44.27c-4.26 0-7 6.65-7 15.4s2.82 15.39 7 15.39 7-6.75 7-15.39-2.79-15.4-7-15.4Zm0 2c2 0 3.91 3.35 4.68 8.38l.09.67a34.9 34.9 0 0 1 .27 4.35 29.61 29.61 0 0 1-1 8l-.16.54c-1 3-2.37 4.84-3.86 4.84-1.89 0-3.66-2.93-4.51-7.42l-.12-.64a33.66 33.66 0 0 1-.41-5.33 36.56 36.56 0 0 1 .22-4l.09-.68c0-.22.06-.44.1-.66l.11-.63c.82-4.52 2.56-7.42 4.5-7.42Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M74.94 51.5a1.002 1.002 0 0 1 .11 2H49.94a1.002 1.002 0 0 1-.12-2h25.12ZM76.86 58.67a1.002 1.002 0 0 1 .12 2h-29a1.002 1.002 0 0 1-.12-2h29ZM74.94 65.8a1.002 1.002 0 0 1 .11 2H49.9a1.002 1.002 0 0 1-.12-2h25.16Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M68.8 74.5a1.25 1.25 0 0 1 2.2 1.18l-.06.12-3.7 6.1a1.25 1.25 0 0 1-2.2-1.18l.06-.12Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M64.99 80.84a1.24 1.24 0 0 1 1.44-.84h.12l6.91 2.18a1.25 1.25 0 0 1-.62 2.42h-.13l-6.91-2.19a1.24 1.24 0 0 1-.81-1.57Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M65.5 37.64a1.26 1.26 0 0 1 1.48-1 23.28 23.28 0 0 1-.55 45.74 1.25 1.25 0 1 1-.44-2.46 20.78 20.78 0 0 0 .49-40.83 1.25 1.25 0 0 1-.98-1.45ZM57.28 37.33a1.255 1.255 0 0 1 2.22 1.17l-.07.12-3.7 6.1a1.26 1.26 0 0 1-2.23-1.17l.06-.12Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M50.23 35.41a1.26 1.26 0 0 1 1.45-.84h.12l6.91 2.18a1.25 1.25 0 0 1-.63 2.42h-.12l-6.91-2.19a1.26 1.26 0 0 1-.82-1.57Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M58.13 36.79a1.254 1.254 0 0 1 .43 2.47 20.77 20.77 0 0 0-.49 40.82 1.25 1.25 0 1 1-.49 2.45 23.28 23.28 0 0 1 .55-45.74Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M38.93.32a1.24 1.24 0 0 1 1.67 0C50.81 9.5 62.99 14.05 78.32 14.5a1.25 1.25 0 0 1 1.2 1.12V35.59a1.24 1.24 0 0 1-1.28 1.22 1.27 1.27 0 0 1-1.22-1.29V16.96h-.27c-14.72-.7-26.71-5.2-36.82-13.89l-.18-.15-.17.15C29.5 11.74 17.5 16.25 2.77 16.95H2.5v15.62c.11 13.94 1.67 24.16 5.83 33.27l.24.52c5.56 11.87 15.44 20.7 30.93 26.42l.25.09.46-.17a68.81 68.81 0 0 0 11.78-5.62l.69-.42a1.25 1.25 0 0 1 1.33 2.11 71.24 71.24 0 0 1-13.83 6.61 1.24 1.24 0 0 1-.85 0c-16.5-5.93-27.09-15.3-33-28C2.5 59.21.68 50.26.16 38.8L.1 37.29V15.77a1.25 1.25 0 0 1 1.11-1.27c15.29-.45 27.51-5 37.72-14.18Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithGlobe2ArrowsIcon';

export default Icon;
